// EAC PLP — filtros nativos: "Ver más" toggle + auto-submit
(function () {
  function init() {
    var form = document.getElementById('CollFilters');
    if (!form) return;

    // "Ver más" / "Ver menos" toggle
    form.querySelectorAll('[data-toggle-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = btn.closest('[data-collapsible]');
        if (!box) return;
        var hidden = box.querySelectorAll('.plp-extra');
        var isHidden = btn.getAttribute('data-open') !== 'true';
        hidden.forEach(function (el) { el.classList.toggle('is-hidden', !isHidden); });
        btn.textContent = isHidden ? '− Ver menos' : '+ Ver más';
        btn.setAttribute('data-open', isHidden ? 'true' : 'false');
      });
    });

    // Auto-submit al marcar/desmarcar (UX como en la tienda actual)
    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () { form.submit(); });
    });

    // Precio: submit al pulsar Enter
    form.querySelectorAll('input[type="number"]').forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); form.submit(); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
